import type { NewsFeedResponse } from '../models';

const identifyNewIds = (
  oldRow: number[],
  response: NewsFeedResponse
): NewsFeedResponse => ({
  ...response,
  news: response.news.filter((item) => !oldRow.includes(item.id) && !item.is_read),
});

export { identifyNewIds };
